import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import { withRouter } from 'react-router-dom';
import styles from './result.module.scss';
import reporting_body from '../../static/images_ae/reporting/reporting_body.png';
import area_head from '../../static/images_ae/reporting/area_head.png';
import line_head from '../../static/images_ae/reporting/line_head.png';
import area_chest from '../../static/images_ae/reporting/area_chest.png';
import line_chest from '../../static/images_ae/reporting/line_chest.png';
import area_stomach from '../../static/images_ae/reporting/area_stomach.png';
import line_stomach from '../../static/images_ae/reporting/line_stomach.png';
import area_others from '../../static/images_ae/reporting/area_others.png';
import line_others from '../../static/images_ae/reporting/line_others.png';
import line_heart from '../../static/images_ae/reporting/line_heart.png';
import line_lungs from '../../static/images_ae/reporting/line_lungs.png';
import area_four_limbs from '../../static/images_ae/reporting/area_four_limbs.png';
import line_four_limbs from '../../static/images_ae/reporting/line_four_limbs.png';
import tip_top_select from '../../static/images_ae/reporting/tip_top_select.png';
import sympton_bg from '../../static/images_ae/reporting/sympton_bg.png';
import bg_back from '../../static/images_ae/reporting/bg_back.png';
import bg_finish_go_on from '../../static/images_ae/reporting/bg_finish_go_on.png';
import tip_bottom_select from '../../static/images_ae/reporting/tip_bottom_select.png';
import organ_heart from '../../static/images_ae/reporting/organ_heart.png';
import doctor_completed from '../../static/images_ae/reporting/doctor_completed.png';
import result_back_home from '../../static/images_ae/alkReport/result_back_home.png';
import result_back_home_white from '../../static/images_ae/alkReport/result_back_home_white.png';
import result_view_report from '../../static/images_ae/alkReport/result_view_report.png';
import result_view_report_white from '../../static/images_ae/alkReport/result_view_report_white.png';
import result_bg from '../../static/images_ae/alkReport/result_bg.png';
import result_card_top from '../../static/images_ae/alkReport/result_card_top.png';
import result_card_bottom from '../../static/images_ae/alkReport/result_card_bottom.png';
import risk_level_0 from '../../static/images_ae/alkReport/risk_level_0.png';
import risk_level_1 from '../../static/images_ae/alkReport/risk_level_1.png';
import risk_level_2 from '../../static/images_ae/alkReport/risk_level_2.png';
import risk_level_3 from '../../static/images_ae/alkReport/risk_level_3.png';
import risk_level_4 from '../../static/images_ae/alkReport/risk_level_4.png';
import risk_level_no from '../../static/images_ae/alkReport/risk_level_no.png';
import question_octagon_fill from '../../static/images_ae/alkReport/question_octagon_fill.png';
import question_r_arrow from '../../static/images_ae/alkReport/question_r_arrow.png';
import symptom_common_q_m_line from '../../static/images_ae/alkReport/symptom_common_q_m_line.png';
import tip_warning_filled from '../../static/images_ae/alkReport/tip_warning_filled.png';
import dialog_evaluate_desc_top from '../../static/images_ae/alkReport/dialog_evaluate_desc_top.png';
import dialog_evaluate_desc_bottom from '../../static/images_ae/alkReport/dialog_evaluate_desc_bottom.png';
import more_report_top from '../../static/images_ae/alkReport/more_report_top.png';
import more_report_bottom from '../../static/images_ae/alkReport/more_report_bottom.png';

const api = new ApiCore();

const item = {
    reportCode: "ALK2022102000007",
    risklevel: 2, 
    symptoms: [
        {
            levelType: null,
            riskLevel: null,
            symptomCode: "S001",
            symptomName: "心悸"
        },
        {
            levelType: null,
            riskLevel: null,
            symptomCode: "S002",
            symptomName: "心悸"
        },
        {
            levelType: null,
            riskLevel: null,
            symptomCode: "S003",
            symptomName: "心悸"
        },
        {
            levelType: null,
            riskLevel: null,
            symptomCode: "S004",
            symptomName: "心悸"
        }
    ]

}

const Chest = (props: any) => {

    const [list, setList] = useState<any>([]);
    const [showDialogMoreReport, setShowDialogMoreReport] = useState<any>(false);
    const [showDialogEvaluate, setShowDialogEvaluate] = useState<any>(false);
    const [headSelected, setHeadSelected] = useState<any>(false);
    const [chestSelected, setChestSelected] = useState<any>(false);
    const [stomachSelected, setStomachSelect] = useState<any>(false);
    const [othersSelected, setOthersSelected] = useState<any>(false);
    const [fourLimbsSelected, setFourLimbsSelected] = useState<any>(false);
    const [selectedCount, setSelectedCount] = useState<any>(0);
    const [organs, setOrgans] = useState<any>(props.organs || {});
    const [savedData, setSavedData] = useState<any>({});
    const [organList, setOrganList] = useState<any>([]);
    const [symptoms, setSymptoms] = useState<any>(props.treatments || []);
    const [scaleList, setScaleList] = useState<any>([]);
    const [askList, setAskList] = useState<any>([]);
    const [activeOrgan, setActiveOrgan] = useState<any>('');
    // const [symptomsResultData, setSymptomsResultData] = useState<any>(props.symptomsResult || item);
    // const [symptomsResult, setSymptomsResult] = useState<any>(props.symptomsResult?.symptoms || item.symptoms);
    const [symptomsResultData, setSymptomsResultData] = useState<any>(props.symptomsResult || {});
    const [symptomsResult, setSymptomsResult] = useState<any>(props.symptomsResult?.symptoms || []);
    useEffect(() => {
        window.document.title = 'ALK肺癌慢病管理风险评估';
        initData();
    }, [])

    const initData = () => {
        let _itemData = sessionStorage.getItem('SymptomsResultData');
        const _item: any = _itemData ? JSON.parse(_itemData) : props.symptomsResult;
        const _param = _item;
        setSymptomsResultData(_item);
        setSymptomsResult(_item.symptoms);
        api.getListReport({ reportCode: _param.reportCode}).then((res: any) => {
            if (res.code == 0) {
                setScaleList(res.data || []);
            }
        });
        api.getQuestionListReport({ reportCode: _param.reportCode }).then((res: any) => {
            if (res.code == 0) {
                const _data = res.data;
                const _highLights = _data.highLights;
                let _questions = _data.questions;
                _questions = _questions.map((val: any) => {
                    let _title = val.title;
                    _highLights.forEach((v: any) => {
                        if (_title.indexOf(v) >= 0 ) {
                            val.hightLightText = _title.replace(v, `<span style="color: #5F2CB7;">${v}</span>`);
                        } else {
                            val.hightLightText = _title;
                        }
                    });
                    return val;
                });
                setAskList(_questions || []);
            }
        });
    }

    const onBack = () => {
        props.history.replace('/ae/home');
    }

    const onDetail = () => {
        // props.history.push('/ae/report/detail');
        props.history.push('/ae/reporting/detail?reportCode=' + symptomsResultData.reportCode);
    }

    const toTool = (val: any) => {
        const formData = {
            crfCode: val.scaleCode
        }
        sessionStorage.setItem('AeScaleFormData', JSON.stringify(formData));
        props.history.push(`/alk/scale?code=${val.code}`);
    }

    const toAskDetail = (val: any) => {
        props.history.push(`/alk/commonAsk/detail?id=${val.id}`);
    }
    
    return (
        <div className={styles.ae_reporting}>
            {/* <div className={styles.tip_top_wrap}>
                <img className={styles.tip_top} src={tip_top_select} alt="" />
                <div className={styles.tip_top_text}>请从下列5个部位中选择您出现不适的部位</div>
            </div> */}
            <div className={styles.head_gap}></div>
            <div className={styles.sympton_select}>
                {/* <div className={styles.sympton_select_img_wrap}>
                    <img src={sympton_bg} alt="" />
                </div> */}
                <div className={styles.risk_gap}></div>
                <div className={styles.risk_content}>
                    <div className={styles.risk_level}>
                        <div className={styles.risk_title}>您的ALK肺癌慢病管理风险评估等级</div>
                        <div className={styles.risk_result}>
                            {
                                symptomsResultData.risklevel !== undefined &&
                                <img src={      symptomsResultData.risklevel == 0 ? 
                                    risk_level_0 : symptomsResultData.risklevel == 1 ? 
                                    risk_level_1 : symptomsResultData.risklevel == 2 ?
                                    risk_level_2 : symptomsResultData.risklevel == 3 ?
                                    risk_level_3 : symptomsResultData.risklevel == 4 ?
                                    risk_level_4 : risk_level_no
                                        } 
                                alt="" />
                            }
                        </div>
                    </div>
                    <div className={styles.sympton_select_text_wrap}>
                        {/* <img src={result_card_top} alt="" /> */}
                        <div className={styles.card_top}>
                        </div>
                        <div className={styles.card_bottom}>
                            <div className={styles.card_bottom_content}>                    
                            {
                                symptomsResult && symptomsResult.map((val: any, key: number) => (
                                    <div key={key} className={
                                        `${ (!val.riskLevel) ? 
                                            styles.level_0 : val.riskLevel == 1 ? 
                                            styles.level_1 : val.riskLevel == 2 ?
                                            styles.level_2 : val.riskLevel == 3 ?
                                            styles.level_3 : val.riskLevel == 4 ?
                                            styles.level_4 : ''
                                        } 
                                        `
                                        } 
                                        // ${ val.symptomName.length >= 5 ? styles.db_item : ''
                                        >
                                        {val.symptomName}{`${val.riskLevel > 0 ? '：' + val.riskLevel + '级' : ''}`}
                                    </div>
                                ))
                            }
                            </div> 
                        {/* <div className={styles.level_0}>1</div>
                        <div className={styles.level_1}>1</div>
                        <div className={styles.level_2}>1</div>
                        <div className={styles.level_3}>1</div>
                        <div className={styles.level_4}>1</div> */}
                        </div>
                        {/* <div className={styles.sympton_select_text}>您选择的症状：</div>
                        <div className={styles.sympton_select_menu}>
                            {
                                symptomsResult && symptomsResult.map((val: any, key: number) => (
                                    <div key={key} className={`${val.selected ? '': ''}`} onClick={() => { symptomsSelected(val, key) }}>{val.symptomName}</div>
                                ))
                            }
                        </div> */}
                    </div>
                    <div className={styles.evaluate_tip}>
                    </div>
                    {
                        scaleList.map((val: any, key: number) => (
                        <div key={key} className={styles.evaluate_next} onClick={ () => { toTool(val)} }>
                            <div className={styles.t}>{val.cname}</div>
                            {/* <div className={styles.b}>{val.ename}</div> */}
                            <div className={styles.b}>{
                                val.symptoms ? val.symptoms.map((v: any) => (v.organName + '-' + v.symptomName)).join(';')
                                :
                                '肺癌通用量表'
                            }</div>
                        </div>    
                        ))
                    }
                </div>
                {/* <div className={styles.evaluate_next}>
                    <div className={styles.t}>癌症患者生命质量测定量表</div>
                    <div className={styles.b}>EORTC QLQ-C30</div>
                </div> */}
            </div>
            <div className={styles.btns_wrap}>
                <div className={styles.btns_back} onClick={() => { onBack() }}>
                    <img className={styles.bootom_top} src={result_back_home_white} alt="" />
                    {/* <div className={styles.text} onClick={() => { onBack() }}></div> */}
                </div>
                <div className={styles.btns_finish_go_on} onClick={onDetail}>
                    <img className={styles.bootom_top} src={result_view_report_white} alt="" />
                    {/* <div className={styles.text} onClick={onDetail}>查看ALK报告</div> */}
                </div>
            </div>
            <div className={styles.more_report_text_more}>
                <div className={styles.title}>
                    <div>评测参考文献：</div>
                    <div onClick={(e) => { setShowDialogEvaluate(true) }}> 
                        <img src={tip_warning_filled} alt="" /> 
                        <span>查看评测说明</span> 
                    </div>
                </div>
                <div className={styles.text}>
                    <div>
                        {`[1]周清, 陆舜, 李勇, 贾福军, 李冠军, & 洪震等. (2022). 洛拉替尼特殊不良反应管理中国专家共识. 中国肺癌杂志,25(8), 12.`}
                    </div>
                    <div>
                        {`[2]常⻅不良事件评价标准(CTCAE) 5.0版（2017）`}
                    </div>
                    <div>
                        {`[3]王可, 李娟, 孙建国, 李力, 张西, & 张建勇等. (2021). 间变性淋巴瘤激酶抑制s剂不良反应管理西南专家建议(2021年版). 中国肺癌杂志, 24(12), 14.`}
                    </div>
                    <div>
                        {`[4]肺癌常用化疗药物说明书（培美曲塞、吉西他滨、紫杉醇、多西他赛、顺铂、长春瑞滨等）`}
                    </div>
                </div>
            </div>
            <div className={styles.more_report_channel} onClick={() => { setShowDialogMoreReport(true); }}></div>
            {
                askList && (askList.length > 0) &&
                <div className={styles.symptom_common_q_a}>
                    <div className={styles.t}></div>
                    <div className={styles.m}>
                        {
                            askList && askList.map((val: any, key: number) => (
                                <div className={styles.item} key={key} onClick={() => { toAskDetail(val) }}>
                                    <img className={styles.item_l} src={question_octagon_fill} alt="" />
                                    <div className={styles.item_m} dangerouslySetInnerHTML={{__html: val.hightLightText}}></div>
                                    {/* <div className={styles.item_m}>肺癌患者出现<span className={styles.high_light}>呼吸困难</span>该如何护理？</div> */}
                                    <img className={styles.item_r} src={question_r_arrow} alt="" />
                                    <img className={styles.bottom_line} src={symptom_common_q_m_line} alt="" />
                                </div>
                            ))
                        }
                    </div>
                    <div className={styles.b}></div>
                </div>
            }
            {
                showDialogEvaluate &&
                <div className={styles.dialog_evaluate_desc}>
                    <div className={styles.text}>
                        <div  className={styles.text_title}>评测说明</div>
                        <div className={styles.text_content}>
                            本程序给出的ALK风险等级评测结果仅供参考，不构
                            成任何诊断和用药意见。您在ALK治疗过程中出现任
                            何症状，应当及时就医并遵从医生的诊断意见。
                        </div>
                        <div className={styles.text_level_t}>分级说明：</div>
                        <div className={styles.text_level_item}>1级：无症状</div>
                        <div className={styles.text_level_item}>2级：有症状，工具性活动受限</div>
                        <div className={styles.text_level_item}>3级：症状严重，自理活动受限</div>
                        <div className={styles.text_level_item}>4级：症状严重，危及生命</div>
                    </div>
                    <img className={styles.dialog_evaluate_desc_top} src={dialog_evaluate_desc_top} alt="" />
                    <img className={styles.dialog_evaluate_desc_bottom} src={dialog_evaluate_desc_bottom} alt="" onClick={(e) => { setShowDialogEvaluate(false) }} />
                </div>
            }
            {
                showDialogMoreReport &&
                <div className={styles.dialog_more_report}>
                    <div className={styles.text}>
                        <div  className={styles.text_title}>ALK靶点不良反应上报渠道</div>
                        <div  className={styles.item_title}>辉瑞制药</div>
                        <div className={styles.text_content}>
                            <div>联系方式：400-910-0055</div>
                            <div>电子邮件：CHN.AEReporting@pfizer.com</div>
                        </div>
                        <div  className={styles.item_title}>罗氏制药</div>
                        <div className={`${styles.text_content_l_r}`}>
                            <div className={styles.l}>联系方式：</div>
                            <div className={styles.r}>021-28922888 / 8008208780（固话）或 4008208780（手机）</div>
                        </div>
                        <div className={`${styles.gap_bottom} ${styles.text_content_l_r}`}>
                            <div className={styles.l}>电子邮件：</div>
                            <div className={styles.r}>ds.drugsafety@roche.com</div>
                        </div>
                        <div  className={styles.item_title}>诺华制药</div>
                        <div className={styles.text_content}>
                            <div>诺华制药（中国）产品热线：</div>
                            <div className={styles.text_indent}>座机拨打：800-810-1555</div>
                            <div className={styles.text_indent}>手机拨打：400-621-3132</div>
                            <div>诺华肿瘤（中国）产品热线：</div>
                            <div className={styles.text_indent}>座机拨打：800-990-0016</div>
                            <div className={styles.text_indent}>手机拨打：400-818-0600</div>
                            <div className={styles.text_indent}>上报网址：ds.drugsafety@roche.com</div>
                        </div>
                        <div  className={styles.item_title}>贝达药业</div>
                        <div className={styles.text_content}>
                            <div>联系方式：0571-86130357转7</div>
                        </div>
                        <div  className={styles.item_title}>武田制药</div>
                        <div className={`${styles.text_content} ${styles.gap_b_0}`}>
                            <div>联系方式：400-069-0980</div>
                        </div>
                        <div className={`${styles.text_content_l_r}`}>
                            <div className={styles.l}>电子邮件：</div>
                            <div className={styles.r}>Cco.smbx.cn-CorpHotline-SCDM@takeda.com</div>
                        </div>
                    </div>
                    <img className={styles.dialog_evaluate_desc_top} src={more_report_top} alt="" />
                    <img className={styles.dialog_evaluate_desc_bottom} src={more_report_bottom} alt="" onClick={(e) => { setShowDialogMoreReport(false) }} />
                </div>
            }
            {
               (showDialogEvaluate || showDialogMoreReport) &&
                <div className={styles.mask} onClick={(e) => { setShowDialogEvaluate(false); setShowDialogMoreReport(false); }}>
                </div>
            }
        </div>
    )
}

export default withRouter(Chest);